<app-document-subheader></app-document-subheader>
@if (this.createBaseLeadInstance$ | async; as baseLeadFormModel) {
  <div
    class="details-content container-fluid h-100"
    >
    <div class="row h-100">
      <div class="col-content d-flex flex-column h-100">
        <div class="page-container partner-details">
          <div class="card card-light w-100">
            <form
              [formGroup]="leadForm"
              (ngSubmit)="onSubmit()"
              [hasUnsavedData]="leadForm"
              >
              <button type="submit" hidden="hidden"></button>
              <div class="card-body">
                <div class="container-fluid">
                  <div class="row mb-2">
                    <div class="col-6 mr-auto">
                      <div class="form-group">
                        <div class="row">
                          <div class="col-6">
                            <label
                              class="form-title-label"
                              for="lastname"
                              translate
                              >LEAD_LBL_LASTNAME</label
                              >
                              <input
                                class="form-control form-title"
                                id="lastname"
                                name="lastname"
                                type="text"
                                formControlName="lastname"
                                oninput="this.value = this.value.toUpperCase()"
                                (blur)="onBlurLastName($event)"
                                checkFormFieldValidity
                                />
                              </div>
                              <div class="col-6">
                                <label
                                  class="form-title-label"
                                  for="firstname"
                                  translate
                                  >LEAD_LBL_FIRSTNAME</label
                                  >
                                  <input
                                    class="form-control form-title"
                                    id="firstname"
                                    name="firstname"
                                    type="text"
                                    formControlName="firstname"
                                    oninput="if (this.value) this.value = this.value[0].toUpperCase() + this.value.slice(1).toLowerCase()"
                                    (blur)="onBlurFirstName($event)"
                                    checkFormFieldValidity
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-md">
                              @if (this.isCrossSell) {
                                <div class="form-group row">
                                  <label class="col-4 col-form-label-sm" translate
                                    >LEAD_LBL_CLIENT</label
                                    >
                                    <div class="col">
                                      <app-typeahead
                                        [routeEndpoint]="'Contacts'"
                                        [entity]="Entity.Contact"
                                        [controlForm]="this.leadForm.controls['clientId']"
                                        [orderBy]="'name asc'"
                                        [allowCustomActions]="true"
                                        [limitToList]="true"
                                      ></app-typeahead>
                                    </div>
                                  </div>
                                }
                                <div class="form-group row">
                                  <label class="col-4 col-form-label-sm" translate
                                    >LEAD_LBL_ADDRESS</label
                                    >
                                    <div class="col">
                                      <input
                                        class="form-control form-control-sm"
                                        id="address"
                                        name="address"
                                        type="text"
                          placeholder="{{
                            'LEAD_PLACEHOLDER_ADDRESS' | translate
                          }}"
                                        formControlName="address"
                                        checkFormFieldValidity
                                        />
                                      </div>
                                    </div>
                                    <div class="form-group row">
                                      <label class="col-4 col-form-label-sm"> </label>
                                      <div class="col">
                                        <div class="row">
                                          <div class="col-2">
                                            <input
                                              class="form-control form-control-sm"
                                              id="zipCode"
                                              name="zipCode"
                                              type="text"
                                              maxlength="5"
                              placeholder="{{
                                'LEAD_PLACEHOLDER_ZIPCODE' | translate
                              }}"
                                              formControlName="zipCode"
                                              mask="00000"
                                              checkFormFieldValidity
                                              />
                                            </div>
                                            <div class="col">
                                              <app-typeahead
                                                [entity]="Entity.ZipCode"
                                                [referenceEndpoint]="'ZipCodes/Cities/'"
                                                [dropdownStyle]="DropdownStyle.DropDown"
                                                [controlForm]="this.leadForm.controls['city']"
                                                [limitToList]="true"
                                                [referenceFilterParentName]="'Code'"
                              [referenceFilterParentValue]="
                                this.leadForm.controls['zipCode'].value
                              "
                                                [valueMember]="'name'"
                                                [displayMember]="'name'"
                                                [dbNameOfId]="'City'"
                                                [dbNameOfName]="'City'"
                                                [referenceField]="'City'"
                                                [showFirstElement]="true"
                                              ></app-typeahead>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="form-group row">
                                        <label class="col-4 col-form-label-sm" translate
                                          >LEAD_LBL_PHONE_NUMBER</label
                                          >
                                          <div class="col">
                                            <input
                                              class="form-control form-control-sm"
                                              id="phoneNumber"
                                              name="phoneNumber"
                                              type="text"
                          [placeholder]="
                            'LEAD_PLACEHOLDER_PHONE_NUMBER' | translate
                          "
                                              formControlName="phoneNumber"
                                              mask="00 00 00 00 00"
                                              checkFormFieldValidity
                                              />
                                            </div>
                                          </div>
                                          <div class="form-group row">
                                            <label class="col-4 col-form-label-sm" translate
                                              >LEAD_LBL_EMAIL</label
                                              >
                                              <div class="col">
                                                <input
                                                  class="form-control form-control-sm"
                                                  id="email"
                                                  name="email"
                                                  type="text"
                                                  formControlName="email"
                                                  [placeholder]="'LEAD_PLACEHOLDER_EMAIL' | translate"
                                                  checkFormFieldValidity
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <label class="col-4 col-form-label-sm" translate
                                                  >LEAD_LBL_PROFESSION</label
                                                  >
                                                  <div class="col">
                                                    <app-typeahead
                                                      [limitToList]="true"
                                                      [dataType]="DataType.Enum"
                                                      [valueMember]="'value'"
                                                      [displayMember]="'name'"
                                                      [referenceEndpoint]="'Views/enum/values'"
                                                      [referenceField]="'Comparanoo.Core.Enums.Profession'"
                                                      [dropdownStyle]="DropdownStyle.DropDown"
                                                      [controlForm]="this.leadForm.get('profession')"
                                                    ></app-typeahead>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col">
                                                <div class="form-group row">
                                                  <label class="col-4 col-form-label-sm" translate
                                                    >LEAD_LBL_CATEGORY</label
                                                    >
                                                    <div class="col">
                                                      <product-category-edit
                          [controlForm]="
                            this.leadForm.controls['productCategoryId']
                          "
                                                        (categoryChange)="onCategoryChange($event)"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div class="form-group row">
                                                      <label class="col-4 col-form-label-sm" translate
                                                        >LEAD_LBL_SALETEAM_MEMBER</label
                                                        >
                                                        <div class="col">
                                                          <app-typeahead
                                                            [entity]="Entity.SalesTeam"
                                                            [routeEndpoint]="'SalesTeams/SalesTeamMembers'"
                          [controlForm]="
                            this.leadForm.controls['salesTeamMember']
                          "
                                                            [limitToList]="true"
                                                            [dbNameOfName]="'UserContactName'"
                                                            [dbNameOfId]="'UserId'"
                                                            [domain]="'UserAspNetUserEmailConfirmed=true,SalesTeamActive=true'"
                                                            [pageSize]="50"
                                                          ></app-typeahead>
                                                        </div>
                                                      </div>
                                                      <div class="form-group row">
                                                        <label class="col-4 col-form-label-sm" translate
                                                          >LEAD_LBL_SALETEAM</label
                                                          >
                                                          <div class="col">
                                                            <app-typeahead
                                                              [entity]="Entity.SalesTeam"
                                                              [routeEndpoint]="'SalesTeams/SalesTeams'"
                                                              [controlForm]="this.leadForm.controls['salesTeam']"
                                                              [limitToList]="true"
                                                              [dbNameOfName]="'SalesTeamName'"
                                                              [dbNameOfId]="'SalesTeamId'"
                          [domain]="
                            !!this.leadForm.controls['salesTeamMember'].value
                              ? 'userId=' +
                                this.leadForm.controls['salesTeamMember'].value
                              : 'userId=0'
                              + ',salesTeamActive=true'
                          "
                                                              [alwaysUseDomain]="true"
                                                            ></app-typeahead>
                                                          </div>
                                                        </div>
                                                        <div class="form-group row">
                                                          <label class="col-4 col-form-label-sm" translate
                                                            >LEAD_LBL_EFFECTIVE_DATE</label
                                                            >
                                                            <div class="col">
                                                              <input
                                                                class="form-control form-control-sm"
                                                                id="effectiveDate"
                                                                name="effectiveDate"
                                                                type="date"
                                                                [max]="this.maxDateMaskSafeGuard"
                                                                formControlName="effectiveDate"
                                                                checkFormFieldValidity
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <app-lead-tabs-form
                                                          [form]="this.leadForm"
                                                          [category]="this.category"
                                                          />
                                                        </div>
                                                      </div>
                                                    </form>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        }
